<template>
    <div>
        <vue-tel-input :value="value"
                       @input="inputEvent"
                       @change="changeEvent"
                       autocomplete="off"
                       :preferredCountries="preferedCountries"
                       :inputOptions="{tabindex: tabindex}"
                       :disabled="disabled"
                       :required="required"
                       mode="international"
                       @validate="validate"
                       :placeholder="placeholder"
                       @country-changed="countryChanged"
                       @focus="$emit('focus')"
                       @blur="$emit('blur', $event)"
        >
        </vue-tel-input>

        <b-form-invalid-feedback :state="state">
            {{ $t(errorMsg) }}
        </b-form-invalid-feedback>
    </div>
</template>

<script>
import debounce from 'lodash/debounce';
import { VueTelInput } from 'vue-tel-input'
import { mask } from 'vue-the-mask'

export default {
    props: {
        value: null,
        required: Boolean,
        placeholder: {
            type: String,
            default: '(__) ___-__-__'
        },
        tabindex: {
            type: [Number, String],
            default: 0
        },
        disabled: Boolean,
        state: {},
        errorMsg: {
            type: String,
            default: 'phone-field.required'
        }
    },
    components: {
        VueTelInput
    },
    directives: { mask },
    data() {
        return {}
    },
    created() {
    },
    mounted() {
    },
    methods: {
        validate(value) {
        },

        countryChanged(country) {
        },

        inputEvent(value) {
            this.$emit('input', value)
        },

        changeEvent(value) {
            this.$emit('change', value)
        }
    },
    computed: {
        preferedCountries() {
            switch (this.$i18n.locale) {
                case 'en':
                    return ['US'];
                case 'fi':
                    return ['FI', 'SE'];
                default:
                    return ['UZ', 'RU', 'KZ'];
            }
        }
    }
}
</script>
